import {Injectable} from '@angular/core';
import {GraphqlService} from "./graphql.service";
import {BaseResponse} from "../common/interfaces/global-interfaces";
import {Store} from "@ngrx/store";
import {AppState} from "../store";
import {NotificationService} from "./notification.service";
import {
  GET_ALL_TRANSLATIONS_KEYWORDS
} from "../store/entities/system-configurations/language-translation/language-translation.graphql";
import {
  LanguageTranslation
} from "../store/entities/system-configurations/language-translation/language-translation.model";

@Injectable({
  providedIn: 'root'
})
export class InitTranslationService {

  constructor(
    private apollo: GraphqlService,
    private store: Store<AppState>,
    private notificationService: NotificationService,
  ) {
  }

  async initTranslations() {
    try {
      const response = await this.apollo.query({
        query: GET_ALL_TRANSLATIONS_KEYWORDS
      });
      const result: BaseResponse<LanguageTranslation[]> = Object.values(Object.values(response)[0])[0];

      if (result?.response?.status) {
        // this.store.dispatch(({translations: result?.data || []}));
      } else {
        throw Error(result?.response?.message);
      }
    } catch (e) {
      this.notificationService.errorMessage(e.message);
    }
  }
}
